import type { ScopesObject } from "@/shared/types";

/**
 * Toggle a file or folder path between included and excluded scope arrays.
 * Mirrors legacy question-bar hover toggle behavior.
 */
export function toggleScopeInclusion(
  prev: ScopesObject,
  path: string,
): ScopesObject {
  if (prev.files.includes(path)) {
    return {
      ...prev,
      files: prev.files.filter((f) => f !== path),
      excludedFiles: [...prev.excludedFiles, path],
    };
  }
  if (prev.scopes.includes(path)) {
    return {
      ...prev,
      scopes: prev.scopes.filter((s) => s !== path),
      excludedScopes: [...prev.excludedScopes, path],
    };
  }
  if (prev.excludedFiles.includes(path)) {
    return {
      ...prev,
      excludedFiles: prev.excludedFiles.filter((f) => f !== path),
      files: [...prev.files, path],
    };
  }
  if (prev.excludedScopes.includes(path)) {
    return {
      ...prev,
      excludedScopes: prev.excludedScopes.filter((s) => s !== path),
      scopes: [...prev.scopes, path],
    };
  }
  return prev;
}
